import Panel, { PanelProps } from './Panel'

export default Panel
export type { PanelProps }
